import { ListItem } from 'material-ui/List';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { PayspotDetailsCard, PayspotDetailsCardTitle } from '../PayspotDetailsCard';

const BillList = styled.div`
  height: 500px;
  overflow-y: auto;
`;

const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ItemKey = styled.span``;
const ItemValue = styled.span``;

const CurrencyItem = styled.div`
  display: flex;
  align-items: center;
  > ${ItemKey} {
    font-size: 18px;
    flex: 1;
    text-align: left;
  }
  > ${ItemValue} {
    font-size: 18px;
    color: #00a23f;
  }
`;

const BillItem = styled.div`
  display: flex;
  align-items: center;
  > ${ItemKey} {
    font-size: 16px;
    flex: 1;
    text-align: left;
  }
  > ${ItemValue} {
    font-size: 12px;
    width: 50px;
    display: flex;
    color: #999;
    > em {
      font-size: 16px;
      margin-left: auto;
      color: #00a23f;
      font-style: normal;
    }
  }
`;

const BillsCard = ({ title, bills }) => {
  const calculateTotal = (currency) =>
    Object.entries(currency).reduce((acc, [bill, count]) => acc + bill * count, 0);

  const NoData = <span style={{ color: 'gray', fontStyle: 'italic' }}>データなし</span>;

  return (
    <PayspotDetailsCard>
      <PayspotDetailsCardTitle>{title}</PayspotDetailsCardTitle>
      <BillList>
        {Object.keys(bills).length === 0 && <Center>{NoData}</Center>}
        {Object.keys(bills).map((currency) => (
          <ListItem
            key={currency}
            initiallyOpen
            primaryTogglesNestedList
            primaryText={<Currency currency={currency} amount={calculateTotal(bills[currency])} />}
            style={{ borderBottom: '1px solid #e5e5e5' }}
            nestedListStyle={{ borderBottom: '1px solid #e5e5e5' }}
            nestedItems={Object.entries(bills[currency]).map(([bill, count]) => (
              <ListItem key={bill} primaryText={<Bill bill={bill} count={count} />} />
            ))}
          />
        ))}
      </BillList>
    </PayspotDetailsCard>
  );
};

const Currency = ({ currency, amount }) => (
  <CurrencyItem>
    <ItemKey>{currency}</ItemKey>
    <ItemValue>{amount}</ItemValue>
  </CurrencyItem>
);

const Bill = ({ bill, count }) => (
  <BillItem>
    <ItemKey>{bill}</ItemKey>
    <ItemValue>
      × <em>{count}</em>
    </ItemValue>
  </BillItem>
);

BillsCard.propTypes = {
  title: PropTypes.string.isRequired,
  bills: PropTypes.object,
};

BillsCard.defaultProps = {
  bills: {},
};

Currency.propTypes = {
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
};

Bill.propTypes = {
  bill: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
};

export default BillsCard;
